import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import useRefreshToken from "../hooks/useRefreshToken";
const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    verifyRefreshToken();
  }, []);

  useEffect(() => {}, [isLoading]);

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            bgcolor: "#0b141d",
          }}
        >
          <CircularProgress size={34} />
          <Box sx={{ fontSize: 13, color: "#8ba3b8", letterSpacing: 2 }}>
            PORTAL EBG
          </Box>
        </Box>
      ) : (
        <Outlet />
      )}
    </>
  );
};
export default PersistLogin;
